import React from "react";
import CommonHeading from "../../../../Components/CommonHeading";
import Selector from "./Select";
import TableHead from "./TableHead";
import { useFormik } from "formik";
import * as Yup from "yup";
import Searchbar from "../../../../Components/Searchbar";
import { useCallback } from "react";
import { useMemo } from "react";
import { useEstimatedSalaryStore } from "../../../../Store/CashControlStore/EstimatedSalaryaStore";
import { useTranslation } from "react-i18next";

export default function Heading() {
  const { loadItems, queryParams, updateParams, years_list, setLoading } =
    useEstimatedSalaryStore();

  const searchAction = useCallback(async (payload) => {
    updateParams({ search_query: payload.term, page: 1 });
    setLoading(true);
    await loadItems(
      new URLSearchParams({
        ...queryParams,
        page: 1,
        search_query: payload.term,
      }).toString()
    );
    setLoading(false);
  });

  const { t } = useTranslation();
  const initialValues = {
    term: "",
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: Yup.object({
      term: Yup.string().min(1, t("Qidiruvni kiriting!")),
    }),
    onSubmit: (values) => {
      searchAction({
        term: values.term,
      });
    },
  });

  const handleChange = (e) => {
    formik.setFieldValue("term", e.target.value);
    searchAction({
      term: e.target.value,
    });
  };

  const yearsOptions = useMemo(() => {
    return (
      years_list?.map((element) => ({
        label: `${element}-yil`,
        value: element,
      })) || []
    );
  }, [years_list]);

  return (
    <CommonHeading
      topItems={
        <>
          <Searchbar
            value={formik.values.term}
            handleChange={(e) => handleChange(e)}
            handleSubmit={formik.handleSubmit}
          />
          <Selector options={yearsOptions} property={t("Yillar")} />
        </>
      }
      tableHead={<TableHead />}
    />
  );
}
